import React from 'react';
import {Input, Textarea} from 'components/vitrade-forms/common';
import {Link} from 'react-router-dom';
import {Demands} from 'api';
import ItemDemand from './ItemDemand.jsx';
import {toastr} from 'react-redux-toastr';
import {withRouter} from 'react-router-dom';
import {LoadingPage} from 'components/loading-page';
import {DateTime} from 'components/UI/DateTime';
import {ShowIf} from 'components/utils';

class DetailDemand extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      demand: null,
      data: [],
      limit: 4,
      order: 'id DESC',
      isLoading: false
    };
  }

  componentDidMount() {
    this.getDemand(this.props.match.params.id);
  }

  componentWillReceiveProps(nextProps) {
    this.getDemand(nextProps.match.params.id);
  }

  getDemand(id) {
    this.setState({isLoading: true});
    Demands.actions.demand.request({id}).then((response) => {
      this.setState({isLoading: false, demand: response.data});
      this.getOtherDemands();
      document.title = response.data ? response.data.content : 'DaklakTrade';
    }, (error) => {
      this.setState({isLoading: false});
      this.props.history.push('/demands');
      toastr.error('Lỗi!', 'Không tìm thấy nhu cầu này');
    });
  }

  getOtherDemands() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isApprove: true
        }
      }
    };
    Demands.actions.list.request(params).then(response => {
      this.setState({data: response.data});
    });
  }

  render() {
    if (!this.state.demand) {
      return null;
    }
    const {isLoading} = this.state;
    return (
      <section className="center">
        <LoadingPage isShow={isLoading} />
        <div className='detail-demand-container'>
          <div className='detail-demand-wrap'>
            <div className='detail-demand-content-left'>
              <div className='detail-demand-content-left-wrap'>
                <div className='content-demand-wrap mb20'>
                  <p className='content-demand-label'>Nội dung:</p>
                  <div className='content-demand'>{this.state.demand.content}</div>
                </div>
                <p>
                  <span className='content-demand-label mb10'>Thời gian: </span>
                  <span className='content-demand-desc'><DateTime dateTime={this.state.demand.createdAt}/></span>
                </p>
                <p>
                  <span className='content-demand-label mb20'>Lĩnh vực:</span>
                  <span className='content-demand-desc mb20'>Chưa có</span>
                  <span className='content-demand-label ml20 mb20'>Nhóm sản phẩm:</span>
                  <span className='content-demand-desc ml10 mb20'>Chưa có</span>
                </p>
                <div className='product-info'>
                  <div className="conpany-wrap">
                    <div className="company-image-wrap">
                      <img width="45" height="42" src={require('assets/images/company/logo.png')}/>
                    </div>
                    <p className="company-name">Cty TNHH Nguyễn Gia Bảo</p>
                    <p className="view-info"><Link className="view-info-link" to="/doanh-nghiep/template">Xem thông tin doanh nghiệp</Link></p>
                  </div>
                </div>
                <form>
                  <Textarea type="text" placeholder="Nội dung yêu cầu..." className="contact-form-group mb20" inputClassName="form-control-areal"/>
                  <div className='content-demand-btn-wrap'>
                    <button className='btn-red-default'>Phản hồi</button>
                  </div>
                </form>
              </div>
            </div>
            <ShowIf condition={this.state.data.length > 0}>
              <div className='detail-demand-content-right mb15'>
                <h2 className='other-demand-title'>Các nhu cầu tương tự</h2>
                <div className='other-demand-wrap'>
                  {
                    this.state.data.map((item, idx) => {
                      if (this.state.demand.id !== item.id) {
                        return (
                          <ItemDemand key={idx} {...item}/>
                        );
                      }
                    })
                  }
                </div>
              </div>
            </ShowIf>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(DetailDemand);



// WEBPACK FOOTER //
// ./components/demand/DetailDemand.jsx